export const COLUMNS_COUNT = 12;
export const GUTTER_SIZE = '24px';

export const SMALL_CONTAINER_WIDTH = 480;
export const MIDDLE_CONTAINER_WIDTH = 640;
export const MEDIUM_CONTAINER_WIDTH = 960;

export const DATE_ISO_FORMAT = 'YYYY-MM-DD';

export const LOGO_RATIO = 1;

export const PORTAL_CONTAINER_ID = 'portal-container';

export const SMALL_BREAKPOINT = `@media screen and (min-width: ${SMALL_CONTAINER_WIDTH}px)`;
export const MIDDLE_BREAKPOINT = `@media screen and (min-width: ${MIDDLE_CONTAINER_WIDTH}px)`;
export const MEDIUM_BREAKPOINT = `@media screen and (min-width: ${MEDIUM_CONTAINER_WIDTH}px)`;

export const IMAGE_DEFAULT_RATIO = 16 / 9;
export const CAROUSEL_DEFAULT_RATIO = 1 / IMAGE_DEFAULT_RATIO; // multiplicative inverse

export const IMAGE_DEFAULT_SIZES = '(max-width: 960px) 100vw, (max-width: 1250px) 50vw, (max-width: 1600px) 40vw, 30vw';
export const IMAGE_DEFAULT_QUALITY = 85;

export const PLACEHOLDER_ICON_SIZE = 40;

export const UPSELL_IMAGE_RATIO = 1;
export const UPSELL_IMAGE_SIZE = 176;

export const SUGGESTED_CURRENCY_CODES = ['EUR', 'USD', 'GBP', 'CHF', 'SGD', 'AUD'];
